<template>
  <div>
    <footer class="main-footer row mx-0 bg-medium pt-5 px-3 p-lg-5">

      <div class="col-12 col-lg-10 mx-auto">
        <div
          class="d-flex flex-lg-row flex-column justify-content-center align-items-center justify-content-lg-between"
        >
          <div class="m-0 mr-lg-5 text-center text-lg-left">
            <router-link to="/">
              <img
                src="@/assets/images/smart_fit/grupo-smart-black.png"
                alt="SmartFit Logotipo"
                style="max-width: 170px"
              />
            </router-link>
          </div>

          <div>
            <nav class="navbar navbar-dark pl-0">
              <ul class="navbar-nav text-center text-lg-left w-100 py-3">
                <li class="nav-item">
                  <router-link to="/marcas" class="nav-link"
                    >Marcas</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/#sobre-nos" class="nav-link"
                    >Sobre nós</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/#faq" class="nav-link">FAQ</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/deixe-seu-perfil" class="nav-link"
                    >Cadastre seu currículo</router-link
                  >
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <nav class="navbar navbar-dark pl-0">
              <ul class="navbar-nav w-100 text-center text-lg-left py-3">
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    :to="{
                      name: 'jobs.group',
                      params: { group: 'corporativas' },
                    }"
                    >Vagas Corporativas</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    :to="{ name: 'jobs.group', params: { group: 'smart-fit' } }"
                    >Vagas Smart Fit</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    :to="{ name: 'jobs.group', params: { group: 'bioritmo' } }"
                    >Vagas Bio Ritmo</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    :to="{ name: 'jobs.group', params: { group: 'studios' } }"
                    >Vagas Studios</router-link
                  >
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <nav class="navbar navbar-dark pl-0">
              <ul
                class="d-flex align-items-center"
                v-if="$route.params && $route.params.group == 'smart-fit'"
              >
                <li class="nav-item ml-4">
                  <a
                    href="https://twitter.com/SmartFitOficial"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/twitter.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.instagram.com/smartfit/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/instagram.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.facebook.com/SmartFit.Oficial"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/facebook.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.linkedin.com/company/smart-fit"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/linkedin.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-Smart-Fit-EI_IE2482840.13,22.htm"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/glassdoor.svg" alt="Encontre-nos no Glassdoor." />
                  </a>
                </li>
              </ul>
              <ul
                class="d-flex align-items-center"
                v-if="$route.params && $route.params.group == 'bioritmo'"
              >
                <li class="nav-item ml-4">
                  <a
                    href="https://twitter.com/bioritmooficial/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/twitter.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.instagram.com/bioritmo/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/instagram.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.facebook.com/BioRitmo.Oficial/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/facebook.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.linkedin.com/company/bio-ritmo-academia/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/linkedin.svg" alt="" />
                  </a>
                </li>
              </ul>
              <ul
                class="d-flex align-items-center"
                v-if="$route.params && $route.params.group == 'studios'"
              >
                <li class="nav-item ml-4">
                  <a
                    href="https://www.instagram.com/racebootcamp/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/twitter.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.facebook.com/racebootcamp/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/facebook.svg" alt="" />
                  </a>
                </li>
              </ul>
              <ul
                class="d-flex align-items-center"
                v-if="$route.params && $route.params.group == 'corporativas'"
              >
                <li class="nav-item ml-4">
                  <a
                    href="https://twitter.com/SmartFitOficial"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/twitter.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.instagram.com/smartfit/"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/instagram.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.facebook.com/SmartFit.Oficial"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/facebook.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.linkedin.com/company/smart-fit"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/linkedin.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a
                    href="https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-Smart-Fit-EI_IE2482840.13,22.htm"
                    target="_blanck"
                  >
                    <img src="@/assets/images/smart_fit/glassdoor.svg" alt="Encontre-nos no Glassdoor." />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
li {
  margin: 0px;
  padding: 0px;
}
.nav-link {
  color: theme-color(dark) !important;
  padding: 0px !important;
  font-size: 1.3rem;
  font-weight: bold;
  &:hover {
    color: theme-color(primary) !important;
  }
}
</style>